import { WebApiModelsEnumerationTypesEmailTemplatePurpose } from "../Repository/eventbookyapi";
import { TextService } from "../Services/TextService";
import { EmailTemplatePurpose } from "../Types/EmailTemplatePurpose";

export const AvailableEmailPurpose = [
    {
        label: TextService.GetText("CreateTemplate_NewMemberRegister"),
        value: EmailTemplatePurpose.MemberGetsActivated
    },
    {
        label: TextService.GetText("CreateTemplate_MemberActivatedNotification"),
        value: EmailTemplatePurpose.MemberGetsActivatedNotification
    }];

export const mapPurposeToText = (purpose: WebApiModelsEnumerationTypesEmailTemplatePurpose | undefined) => {
    switch (purpose) {
        case EmailTemplatePurpose.MemberGetsActivated:
            return TextService.GetText("CreateTemplate_NewMemberRegister");
        case EmailTemplatePurpose.MemberGetsActivatedNotification:
            return TextService.GetText("CreateTemplate_MemberActivatedNotification");
        default:
            return "";
    }
}